import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  tags: string[];
  author: string;
  publishDate: string;
  readTime: string;
  featured?: boolean;
}

export default function ArticleCard({
  title,
  slug,
  categoryName,
  categoryId,
  excerpt,
  tags,
  author,
  publishDate,
  readTime,
  featured,
}: ArticleCardProps) {
  return (
    <article className={`group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200/60 ${featured ? 'lg:col-span-2 lg:flex' : ''}`}>
      <Link to={`/article/${slug}`} className={`block p-5 md:p-6 ${featured ? 'lg:flex-1' : ''}`}>
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${categoryId}`}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>

        <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
          {title}
        </h3>

        <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
          {excerpt}
        </p>

        <div className="flex items-center gap-2 flex-wrap mb-3">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded bg-background-100 text-foreground-500"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span>{author}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{publishDate}</span>
        </div>
      </Link>
    </article>
  );
}